import "../css/About.css";

const About = () => {
  return (
    <main className="salon-about">

      {/* 1. HERO */}
      <section className="about-hero">
        <h1>Our Story</h1>
        <p>
          A salon shaped by intention,<br />
          calm, and timeless beauty.
        </p>
      </section>

      {/* 2. STORY */}
      <section className="about-story">
        <div className="story-text">
          <h2>Where It Began</h2>
          <p>
            Élan was created as a response to fast beauty.
            A place where every service slows down,
            listens, and adapts to the individual.
          </p>
          <p>
            We believe luxury is not excess —
            it’s time, attention, and care.
          </p>
        </div>
        <div className="story-image" />
      </section>

      {/* 3. DIVIDER */}
      <section className="about-divider">
        <span>EST. ÉLAN</span>
      </section>

      {/* 4. SPACE */}
      <section className="about-space">
        <div className="space-image" />
        <div className="space-text">
          <h2>The Space</h2>
          <p>
            Our interiors are designed to feel light,
            quiet, and uncluttered — allowing
            beauty to take center stage.
          </p>
        </div>
      </section>

      {/* 5. VALUES */}
      <section className="about-values">
        <div>
          <span>Care</span>
          <p>Every guest is treated with intention.</p>
        </div>
        <div>
          <span>Craft</span>
          <p>Precision, experience, and expertise.</p>
        </div>
        <div>
          <span>Balance</span>
          <p>Beauty without rush or pressure.</p>
        </div>
      </section>

      {/* 6. TEAM PREVIEW */}
      <section className="about-team">
        <h2>The Team</h2>
        <p>
          A collective of stylists, artists,
          and specialists guided by craft.
        </p>
      </section>

      {/* 7. FULL IMAGE */}
      <section className="about-full-image" />

      {/* 8. CLOSING */}
      <section className="about-closing">
        <p>
          Beauty is personal.<br />
          We treat it that way.
        </p>
      </section>

    </main>
  );
};

export default About;
